<template>
	<div>
		<div class="applyTop">
			<div class="flex flex-align-center flex-jus-between">
				<img src="../../../static/images/icon-arrowLeft.png" class="arrow" @click="goBack"/>
				<img src="../../../static/images/icon-my.png" class="arrow" @click="$router.push({name: 'my'})"/>
			</div>
			<div class="avatar flex flex-align-center flex-jus-center"><img :src="avatar" alt="" /></div>
			<div class="name">{{ nickname }}</div>
		</div>

		<div class="applyForm">
			<div class="applyForm-title flex">
				<img src="../../../static/images/my/apply-circle.png" />
				<div class="text">会员申请入会</div>
			</div>
			<div class="error" v-if="status == 2">
				失败原因：{{cause}}
			</div>
			<div class="applyForm-line flex flex-align-center flex-jus-between">
				<div class="left"><span class="must">*</span>姓名</div>
				<input :disabled="disabled" type="text" class="input flex-1" placeholder="请输入真实姓名" maxlength="10" v-model.trim="truename"/>
			</div>

      <div class="applyForm-line flex flex-align-center flex-jus-between">
        <div class="left">艺名</div>
        <input :disabled="disabled" type="text" class="input flex-1" placeholder="请输入艺名" maxlength="10" v-model.trim="stage_name"/>
      </div>

			<div class="applyForm-line flex flex-align-center flex-jus-between" @click="disabled ? '' : genderPop = true">
				<div class="left"><span class="must">*</span>性别</div>
				<div class="flex-1 right" v-if="!sex">请选择</div>
				<div class="flex-1 right" v-else style="color: #000000;">{{ genderList[sex - 1] }}</div>
				<img src="../../../static/images/icon-arrowRight.png" class="arrow" />
			</div>



			<div class="applyForm-line flex flex-align-center flex-jus-between" @click="disabled? '' : datePicker = true">
				<div class="left"><span class="must">*</span>出生年月</div>
				<div class="flex-1 right" v-if="!birthday">请选择</div>
				<div class="flex-1 right" v-else style="color: #000000;">{{ birthday }}</div>
				<img src="../../../static/images/icon-arrowRight.png" class="arrow" />
			</div>

			<div class="applyForm-line flex flex-align-center flex-jus-between" @click="disabled ? '' : areaPicker = true">
				<div class="left"><span class="must">*</span>所在省</div>
				<div class="flex-1 right" v-if="!native_place">请选择</div>
				<div class="flex-1 right" v-else style="color: #000000;">{{ native_place }}</div>
				<img src="../../../static/images/icon-arrowRight.png" class="arrow" />
			</div>

			<div class="applyForm-line flex flex-align-center flex-jus-between" @click="disabled ? '' : educationPop = true">
				<div class="left"><span class="must">*</span>学历</div>
				<div class="flex-1 right" v-if="education == -1">请选择</div>
				<div class="flex-1 right" v-else style="color: #000000;">{{ educationList[education] }}</div>
				<img src="../../../static/images/icon-arrowRight.png" class="arrow" />
			</div>

      <div class="applyForm-line flex flex-align-center flex-jus-between">
        <div class="left"><span class="must">*</span>民族</div>
        <input :disabled="disabled" type="text" class="input flex-1" placeholder="请输入" maxlength="10" v-model.trim="national"/>
      </div>

      <div class="applyForm-line flex flex-align-center flex-jus-between">
        <div class="left"><span class="must">*</span>身份证号</div>
        <input :disabled="disabled" type="text" class="input flex-1" placeholder="请输入" maxlength="18" v-model.trim="idcard"/>
      </div>

			<div class="applyForm-line flex flex-align-center flex-jus-between" @click="disabled ? '' : politicsPop = true">
				<div class="left"><span class="must">*</span>政治面貌</div>
				<div class="flex-1 right" v-if="politics == -1">请选择</div>
				<div class="flex-1 right" v-else style="color: #000000;">{{ politicsList[politics] }}</div>
				<img src="../../../static/images/icon-arrowRight.png" class="arrow" />
			</div>

			<div class="applyForm-line flex flex-align-center flex-jus-between" @click="disabled ? '' : professionPopShow = true">
				<div class="left"><span class="must">*</span>专业领域</div>
				<div class="flex-1 right" v-if="professionListSelect.length == 0">请选择</div>
				<div class="flex-1 right flex flex-align-center flex-row-reverse" v-else>
					<div class="right-item" v-for="(item, index) in professionListSelect" :key="index">{{ item }}</div>
				</div>

				<img src="../../../static/images/icon-arrowRight.png" class="arrow" />
			</div>

			<div class="applyForm-line flex flex-align-center flex-jus-between">
				<div class="left"><span class="must">*</span>职务职称</div>
				<input :disabled="disabled" type="text" class="input flex-1" placeholder="请输入" maxlength="20" v-model.trim="position"/>
			</div>
			<div class="applyForm-line flex flex-align-center flex-jus-between">
				<div class="left"><span class="must">*</span>任职单位</div>
				<input :disabled="disabled" type="text" class="input flex-1" placeholder="请输入" maxlength="20" v-model.trim="unit"/>
			</div>

			<div class="applyForm-line flex flex-align-center flex-jus-between">
				<div class="left"><span class="must">*</span>联系电话</div>
				<input :disabled="disabled" type="text" class="input flex-1" placeholder="请输入" maxlength="11" v-model.trim="mobile"/>
			</div>
			<div class="applyForm-line flex flex-align-center flex-jus-between">
				<div class="left"><span class="must">*</span>电子邮箱</div>
				<input :disabled="disabled" type="text" class="input flex-1" placeholder="请输入" maxlength="120" v-model.trim="email"/>
			</div>
			<div class="applyForm-line flex flex-align-center flex-jus-between">
				<div class="left"><span class="must">*</span>邮政编码</div>
				<input :disabled="disabled" type="text" class="input flex-1" placeholder="请输入" maxlength="20" v-model.trim="postcode"/>
			</div>

			<!-- 通讯地址 -->
			<div class="applyForm-col">
				<div class="title"><span class="must">*</span>通讯地址</div>
				<div class="textList"><textarea :disabled="disabled" name="" placeholder="请输入通讯地址..." maxlength="250" v-model="address"></textarea></div>
			</div>

			<!-- 专业背景 -->
			<div class="applyForm-col">
				<div class="title"><span class="must">*</span>专业背景</div>
				<div class="textList"><textarea :disabled="disabled" name="" placeholder="请输入描述说明您的专业背景..." maxlength="250" v-model="background"></textarea></div>
			</div>

			<!-- 主要成就 -->
			<div class="applyForm-col">
				<div class="title flex flex-align-center">
					<div><span class="must">*</span>主要成就</div>
					<!-- <van-popover v-model="showPopover" trigger="click" theme="dark">
						<div style="padding: 8px;font-size: 12px;color: #FFFFFF;max-width: 100px;">{{ achievements }}</div>
						<template #reference>
							<van-icon name="question" style="margin-top: 2px;" />
						</template>
					</van-popover> -->
				</div>
				<div class="textList"><textarea :disabled="disabled" name="" placeholder="请输入描述说明您的主要成就..." maxlength="250" v-model="achievements"></textarea></div>
			</div>

			<!-- 入会愿望 -->
			<div class="applyForm-col">
				<div class="title"><span class="must">*</span>入会愿望</div>
				<div class="textList"><textarea :disabled="disabled" name="" placeholder="请输入描述说明您的入会愿望..." maxlength="250" v-model="dream"></textarea></div>
			</div>

			<div class="applyForm-line flex flex-align-center flex-jus-between">
				<div class="left"><span class="must">*</span>推荐人</div>
				<input :disabled="disabled" type="text" class="input flex-1" placeholder="请输入" maxlength="10" v-model="recommend_name"/>
			</div>

			<!-- 本人头像 -->
			<div class="applyPicTitle"><span class="must">*</span>本人头像（1张）</div>
			<van-uploader :disabled="disabled" :deletable="vipStatus != 0 && vipStatus != 1" v-model="fileList" :max-count="1" />

			<!-- 图片上传 -->
			<!-- <input type="file" id="fileExport" @change="handleFileChange" ref="inputer" > -->

			<div v-if="is_pay == 0" class="membershipFee">
				<div class="flex flex-align-center flex-jus-between">
					<div class="feeTitle">预缴会费</div>
					<div class="money">￥{{vip_apply_price}}</div>
				</div>
				<div class="feeTip">
					申请时预缴会费，如申请失败将会退还原账户
				</div>
			</div>
      <!-- v-if="vipStatus == 2 || (vipStatus == 0 && is_pay == 0) || is_vip == 0" -->
			<div class="submitBtn" @click="submitForm">
				<img src="../../../static/images/my/applyBtn.png" alt="">
			</div>
		</div>

		<!-- 性别弹窗 -->
		<van-popup v-model="genderPop" round position="bottom"><van-picker show-toolbar :columns="genderList" @cancel="genderPop = false" @confirm="genderConfirm" /></van-popup>

		<!-- 政治面貌 弹窗 -->
		<van-popup v-model="politicsPop" round position="bottom"><van-picker show-toolbar :columns="politicsList" @cancel="politicsPop = false" @confirm="politicsConfirm" /></van-popup>


		<!-- 学历 弹窗 -->
		<van-popup v-model="educationPop" round position="bottom"><van-picker show-toolbar :columns="educationList" @cancel="educationPop = false" @confirm="educationConfirm" /></van-popup>


		<!-- 时间弹窗 -->
		<van-popup v-model="datePicker" round position="bottom">
			<van-datetime-picker v-model="currentDate" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate" @cancel="datePicker = false" @confirm="dateConfirm" />
		</van-popup>

		<!-- 专业领域弹窗 -->
		<van-popup v-model="professionPopShow" round position="bottom" :safe-area-inset-bottom="true">
			<div class="professionPop">
				<div class="title flex flex-align-center ">
					<div class="title-cancel" @click="professionPopShow = false">取消</div>
					<div class="title-content flex-1">请选择擅长的专业领域</div>
					<div class="title-confirm" @click="confirmPro">确定</div>
				</div>

				<div class="tips">最多支持选择3个擅长的专业领域</div>
				<div class="selectList flex flex-wrap flex-align-center">
					<div class="item" v-for="(item, index) in professionList" :key="index" @click="proSelec(index)" :class="{ 'item-active': professionListCheck[index] }">{{ item.name }}</div>
				</div>
			</div>
		</van-popup>

		<!-- 地区弹窗 -->
		<van-popup v-model="areaPicker" round position="bottom"><van-area title="请选择" :area-list="areaList" :columns-num="2" @cancel="areaPicker = false" @confirm="areaConfirm" /></van-popup>

	</div>
</template>

<script>
/* eslint-disable */
import areaList from '../../area.js';
export default {
	watch: {},
	data() {
		return {
			vipStatus: null,
			is_vip: null,
			// 姓名
			truename: '',
			// 性别
			genderPop: false,
			sex: null,
			genderList: ['男','女'], //接口是 性别:1=男,2=女
			// 时间选择器
			datePicker: false,
			minDate: new Date(1900, 0, 1),
			maxDate: new Date(2030, 12, 31),
			currentDate: new Date(1990, 0, 1),
			birthday: '', //出生年月
			// 学历
			educationPop: false,
			education: -1,
			educationList: ["初中", "高中", "专科", "本科", "研究生", "博士", "其他"],

      stage_name: '', //	String艺名【新增】
      national: '', //	Strin 民族【新增】
      idcard: '',//	String身份证【新增】
      //address: '',//	String通讯地址【新增】
			// 地区弹窗
			areaPicker: false,
			areaList: areaList,
			// 常住城市  改为籍贯
			native_place: '',


			// 政治面貌
			politicsPop: false,
			politics: -1,
			politicsList: ["群众", "共青团员", "预备党员", "党员"],
			// 专业领域弹窗
			professionPopShow: false,
			professionList: [],
			professionListCheck: [],
			professionListCount: 0,
			professionListSelect: [], // 选择的专业领域的数组
			professionListIdSelect: [], // 选择的专业领域的id数组
			major_ids: '',
			// 职务职称
			position: '',
			// 任职单位
			unit: '',
			// 手机号
			mobile: '',
			// 电子邮箱
			email: '',
			// 邮政编号
			postcode: '',
			// 通讯地址
			address: '',
			// 专业背景
			background: '',
			// 主要成就
			achievements: '',
			// 入会愿望
			dream: '',
			// 推荐人
			recommend_name: '',

			// 主要成就 冒泡框
			showPopover: false,

			// 证件照
			fileList: [],

			avatar: '',
			nickname: '',


			is_pay: null, // 0 需缴费 1不需要缴费
			vip_apply_price: '',

			status: null, // 状态
			cause: '', // 失败原因
			isLoading: false
		};
	},
	created() {
		// this.vipStatus = Number(this.$route.query.vipStatus)
		this.getUserInfo()

		this.avatar = localStorage.getItem('avatar')
		this.nickname = localStorage.getItem('nickname')
		this.getProfessionList()
		this.getData()

		// this.$get('api/ranking/config').then(res => {
		// 	this.achievements = res.data.achievements
		// 	console.log("/api/ranking/config",res);

		// })

		// this.$get('api/index/get_apply_config').then(res => {
		// 	console.log(res);
		// 	this.professionList = res.data
		// })
	},
  computed: {
	  disabled({vipStatus}) {
	    // return [0, 1].includes(vipStatus);
      return false;
    },
  },
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '申请入会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		goBack() {
			if (window.history.length <=1 ) {
				this.$router.push('/home')
			} else {
				this.$router.back(-1)
			}
		},
		getUserInfo() {
			this.$get('api/user/userInfo').then(res => {
				let result = res.data
				this.is_vip = result.is_vip
				this.vipStatus = result.vip.status
			})
		},
		getData() {
			this.$get('api/user/getVipApply').then(res => {
				let pay = res.data.pay
				this.is_pay = pay.is_pay
				this.vip_apply_price = pay.vip_apply_price
				let result = res.data
				this.truename = result.truename
				this.sex = result.sex
				this.birthday = result.birthday
				this.native_place = result.native_place
				this.education = result.education
				this.politics = result.politics
				this.major_ids = result.major_ids || ''
        // 新增
        // stage_name: '', //	String艺名【新增】
        //   national: '', //	Strin 民族【新增】
        //   idcard: '',//	String身份证【新增】
        //   //address: '',//	String通讯地址【新增】
        this.stage_name = result.stage_name || ''
        this.national = result.national
        this.idcard = result.idcard
				if (result.major_ids) {
					this.professionListIdSelect = result.major_ids.split(',')
					this.professionListCount = this.professionListIdSelect.length
				}
				setTimeout(() => {
					this.professionListSelect = this.professionList.filter(item => this.professionListIdSelect.includes(String(item.id))).map(item=> {return item.name})
					for (let i = 0;i<this.professionList.length;i++) {
						let ind = this.professionListIdSelect.findIndex(item => item == this.professionList[i].id)
						if (ind>-1) {
							this.$set(this.professionListCheck, `${i}`, !this.professionListCheck[i]);
						}
					}
				}, 0);
				this.position = result.position
				this.unit = result.unit
				this.mobile = result.mobile
				this.email = result.email
				this.postcode = result.postcode
				this.address = result.address
				this.background = result.background
				this.achievements = result.achievements
				this.dream = result.dream
				this.recommend_name = result.recommend_name
				if (result.certificates) {
					this.certificates = result.certificates
					this.fileList = [{
						url: this.certificates,
						bool: true
					}]
				}
				this.status = result.status
				this.cause = result.cause
			})
		},
		// 获取专业领域
		getProfessionList() {
			this.$get('api/common/getMajorIds').then(res => {
				this.professionList = res.data
			})
		},
		// 专业领域选择
		proSelec(index) {
			if (!this.professionListCheck[index] && this.professionListCount == 3) {
				this.$toast.fail('超过上限');
				return;
			}
			if (!this.professionListCheck[index]) this.professionListCount++;
			else if (this.professionListCount > 0) this.professionListCount--;
			this.$set(this.professionListCheck, `${index}`, !this.professionListCheck[index]);
		},
		// 专业领域 确认
		confirmPro() {
			this.professionListSelect = [];
			this.professionListIdSelect = [];
			for (let i in this.professionList)
				if (this.professionListCheck[i]) {
					this.professionListIdSelect.push(this.professionList[i].id);
					this.professionListSelect.push(this.professionList[i].name);
				}
			this.professionPopShow = false;
		},
		// 学历
		educationConfirm(e) {
			let i = 0
			for (i in this.educationList)
				if (this.educationList[i] == e) break
			this.education = i
			this.educationPop = false
		},
		// 性别确认
		genderConfirm(e) {
			if (e == '女') this.sex = 2
			else if (e == '男') this.sex = 1

			this.genderPop = false
		},
		// 政治面貌确认
		politicsConfirm(e) {
			let i = 0
			for (i in this.politicsList)
				if (this.politicsList[i] == e) break
			this.politics = i
			this.politicsPop = false
		},
		// 出生 年月确认
		dateConfirm(e) {
			this.birthday = e.getFullYear() + '-' + (e.getMonth() + 1) + '-' + e.getDate();
			this.datePicker = false;
		},
		// 地区 确认
		areaConfirm(e) {
			this.native_place = e[0].name + ',' + e[1].name;
			this.areaPicker = false;
		},
		checkForm() {
			if (!this.truename) { this.$toast.fail('请输入姓名'); return false; }
			if (!this.sex) { this.$toast.fail('请选择性别'); return false; }
			if (!this.birthday) { this.$toast.fail('请选择出生年月'); return false; }
			if (this.education == -1) { this.$toast.fail('请选择学历'); return false; }
			if (!this.native_place) { this.$toast.fail('请选择常住城市'); return false; }
			// 新增
      if (!this.national) { this.$toast.fail('请输入民族'); return false; }
      if (!this.idcard) { this.$toast.fail('请输入身份证号'); return false; }



			if (this.politics == -1) { this.$toast.fail('请选择政治面貌'); return false; }
			if (!this.professionListCount) { this.$toast.fail('请选择专业领域'); return false; }
			if (!this.position) { this.$toast.fail('请输入职务职称'); return false; }
			if (!this.unit) { this.$toast.fail('请输入任职单位'); return false; }
			if (!this.mobile) { this.$toast.fail('请输入手机号'); return false; }
			let regxMobile = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
			if (!regxMobile.test(this.mobile)) { this.$toast.fail('请输入正确的手机号'); return false; }
			if (!this.email) { this.$toast.fail('请输入电子邮箱'); return false; }
			//Email正则
			let regx = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
			if (!regx.test(this.email)) { this.$toast.fail('请输入正确的电子邮箱'); return false; }

			if (!this.postcode) { this.$toast.fail('请输入邮政编号'); return false; }
			if (!this.address) { this.$toast.fail('请输入通讯地址'); return false; }
			if (!this.background) { this.$toast.fail('请输入专业背景'); return false; }
			if (!this.achievements) { this.$toast.fail('请输入主要成就'); return false; }
			if (!this.dream) { this.$toast.fail('请输入入会愿望'); return false; }
			if (!this.recommend_name) { this.$toast.fail('请输入推荐人'); return false; }


			if (this.fileList.length == 0) { this.$toast.fail('请选择证件照'); return false; }
			return true
		},
		// 上传文件
		submitForm() {
			if (!this.checkForm()) return
			if (this.isLoading) {
				return
			}
			this.isLoading = true
			if (this.fileList[0].bool) {
				this.submit(this.certificates)
			} else {
				let formData=new FormData();//new一个formData事件
				formData.append("file",this.fileList[0].file);

				this.$post('api/common/upload',formData,{
					'Content-Type':'multipart/form-data'
				}).then(res2 => {
					let imgUrl = res2.data.url
					this.submit(imgUrl)
				}).catch(() => {
					this.isLoading = false
				})
			}
		},
		submit(imgUrl) {
			this.$post('api/user/vipApply', {
				truename: this.truename,
				birthday: this.birthday,
				sex: this.sex,
				education: this.education,
				native_place: this.native_place,
				politics: this.politics,
				major_ids: this.professionListIdSelect.join(','),
				position: this.position,
				unit: this.unit,
				mobile: this.mobile,
				email: this.email,
				postcode: this.postcode,
				address: this.address,
				background: this.background,
				achievements: this.achievements,
				dream: this.dream,
				recommend_name: this.recommend_name,
				certificates: imgUrl, // 本人证件照
        stage_name: this.stage_name, //	String艺名【新增】
        national: this.national, //	Strin 民族【新增】
        idcard: this.idcard,//	String身份证【新增】
        //address: '',//	String通讯地址【新增】
			}).then(res => {
				if (res.code == 2000) {
					let result = res.data
					this.order_no = result.pay.order_no
					if (this.is_pay == 0) {
						this.pay()
					} else {
						this.$toast.success('提交成功！')
						setTimeout(() => {
							this.$router.go(-1)
						},1500)
						this.isLoading = false
					}
				} else {
					this.isLoading = false
					this.$toast.fail('请检查表单！')
				}
			}).catch(() => {
				this.isLoading = false
			})
		},
		pay() {
			this.$post('api/pay/unifyPay', {
				order_no: this.order_no,
				pay_type: 1,
				is_jssdk: 1
			}).then(res => {
				let result = res.data
				this.$wx.chooseWXPay({
					"appId": result.appId,
					"timestamp": result.timeStamp,
					"nonceStr": result.nonceStr,
					"package": result.package,
					"signType": 'MD5',
					"paySign": result.paySign,
					success: () => {
						this.$toast.success('预缴成功，请等待审核！')
						this.isLoading = false
						setTimeout(() => {
							this.$router.go(-1)
						},1500)
					},
					cancel: () => {
						this.isLoading = false
					},
					fail: () => {
						this.isLoading = false
					}
				})
			}).catch(() => {
				this.isLoading = false
			})
		}
	}
};
</script>
<style>
	.input:disabled{
		background-color : #fff;
		color: #333;
		opacity:1;
		-webkit-text-fill-color:#333;
		-webkit-opacity:1;
	}
	textarea:disabled {
		background-color : #fff;
		color: #333;
		opacity:1;
		-webkit-text-fill-color:#333;
		-webkit-opacity:1;
	}
</style>
<style scoped lang="stylus">
.must {
  color #DE113C
}

// 专业领域的弹窗
.professionPop
	padding 44px 30px
	.title
		.title-cancel
			font-size 30px
			color #000000
		.title-content
			font-size 34px
			font-weight bold
			color #0A0A0A
			text-align center
		.title-confirm
			font-size 30px
			font-weight bold
			color #DE113C
	.tips
		width 100%
		text-align center
		margin-top 24px
		font-size 24px
		font-weight 500
		color #B1B1B1
	.selectList
		.item
			margin-top 40px
			margin-right 10px
			width 160px
			height 60px
			line-height 60px
			background #FFFFFF
			border 2px solid #B1B1B1
			border-radius 38px
			font-size 28px
			color #000000
			text-align center
		.item-active
			background #FFD6DF !important
			border 2px solid #DE113C !important
			color #DE113C !important
.applyTop
	background-image url('../../../static/images/my/applyBG.png')
	background-size 100% 100%
	background-position center
	width 100vw
	height 420px
	padding 24px 30px
	.arrow
		width 52px
		height 52px
	.avatar
		background-image url('../../../static/images/my/avatarBG.png')
		background-size 100% 100%
		background-position center
		width 120px
		height 120px
		margin 0 auto
		margin-top -10px
		img
			width 90px
			height 90px
			border-radius 50%
	.name
		margin-top 26px
		text-align center
		width 100%
		font-size 32px
		font-weight 800
		color #FFEBE8
.applyForm
	width 100%
	background #FFFFFF
	border-radius 40px 40px 0px 0px
	padding 40px 30px
	margin-top -100px
	.applyForm-title
		img
			width 38px
			height 46px
		.text
			margin-left -26px
			font-size 32px
			font-weight bold
			color #000000
	.applyForm-line
		padding 36px 0
		font-size 28px
		color #232220
		border-bottom 1px solid #E6E6E6
		.right
			text-align right
			font-size 28px
			color #B1B1B1
			.right-item
				width 146px
				height 52px
				line-height 52px
				text-align center
				border 2px solid #DE113C
				border-radius 26px
				font-size 28px
				color #DE113C
				margin-right 20px
		.arrow
			width 14px
			height 30px
			margin-left 16px
		input
			text-align right
			font-size 28px
			color #333333
		input::-webkit-input-placeholder
			color #B1B1B1
			font-size 28px
		input::-moz-placeholder /* Mozilla Firefox 19+ */
			color #B1B1B1
			font-size 28px
		input:-moz-placeholder /* Mozilla Firefox 4 to 18 */
			color #B1B1B1
			font-size 28px
		input:-ms-input-placeholder /* Internet Explorer 10-11 */
			color #B1B1B1
			font-size 28px
	.applyForm-col
		padding 36px 0
		border-bottom 1px solid #E6E6E6
		.title
			font-size 28px
			font-weight bold
			color #232220
		.textList
			margin-top 28px
			width 100%
			height 120px
			textarea
				width 100%
				height 100%
				background-color #FFFFFF
				border none
				resize none
				font-size 28px
				color #000000
			textarea::-webkit-input-placeholder
				font-size 28px
				color #B1B1B1
			textarea:-moz-placeholder
				font-size 28px
				color #B1B1B1
			textarea::-moz-placeholder
				font-size 28px
				color #B1B1B1
			textarea::-ms-input-placeholder
				font-size 28px
				color #B1B1B1
	.applyPicTitle
		margin 34px 0
		font-size: 28px;
		font-weight: bold;
		color: #000000;
	.membershipFee
		margin-top 34px
		width 690px
		background-color #F9F9F9
		border-radius 20px
		padding 24px
		.feeTitle
			font-size 28px
			color #232220
			line-height 40px
			font-weight bold
			margin-bottom 40px
		.money
			font-size 28px
			color #DE113C
			line-height 40px
			font-weight bold
			margin-bottom 40px
		.feeTip
			font-size 24px
			color #9e9e9e
			line-height 34px
	.submitBtn
		width 376px
		height 92px
		margin 60px auto
		img
			width 100%
			height 100%
.error
	background #FCF6ED
	padding 16px 30px
	font-size 24px
	color #DE8C17
	margin-top 32px
</style>
